/** The device's own IANA timezone, ignoring any app-level override. */
const getDeviceTimeZone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export default getDeviceTimeZone;
